import React from "react";
import Home from "./components/Home/Home";
import "./style/style.scss";
function App() {
    return (
        <>
            <Home />
        </>
    );
}

export default App;
